export const convertirDecimalAnios = (decimal) => {
    const decimalValue = Number(decimal);
    const totalMeses = Math.round(decimalValue * 12);
    const anios = Math.floor(totalMeses / 12);
    const meses = totalMeses % 12;
    const totalSemanas = Math.max(1, Math.round(decimalValue * 52));
    
    if(anios >= 199 || decimal === "0.76000000000000001" ){
      return `1 vez`;
    } else if (anios === 120 || decimal === "0.82" || decimal === "0.81999999999999995"){
      return `Indefinido`;
    } else if (decimalValue * 12 < 1) {
      return `${totalSemanas} semana${totalSemanas > 1 ? "s" : ""}`;
    } else if (anios > 0 && meses > 0) {
      return `${anios} año${anios > 1 ? "s" : ""} y ${meses} mes${meses > 1 ? "es" : ""}`;
    } else if (anios > 0) {
      return `${anios} año${anios > 1 ? "s" : ""}`;
    } else {
      return `${meses} mes${meses > 1 ? "es" : ""}`;
    }
};
  
